import { AnimatePresence } from 'framer-motion';

import { useViewerRoute } from '../../../../contexts/ViewerRoute';
import { GOOGLE_EVENT_ID } from '../../../../constant/googleEventId';
import useCtaButtonAnimation from '../../../../hooks/useCtaButtonAnimation';
import useBulkCtaButtonSubmit from '../../../../hooks/mutation/cta/useBulkCtaButtonSubmit';
import * as Styled from '../../ctaButton.styles';

interface Props {
  id: string;
  button: string;
  url: string;
  page: number;
  isPreview?: boolean;
}

const CtaButton = ({ id, button, url, page, isPreview }: Props) => {
  const { historyId } = useViewerRoute();

  const { mutate: submitBulkCtaButtonAction } = useBulkCtaButtonSubmit();

  const {
    buttonAnimationControls,
    textAnimationControls,
    textWrapperAnimationControls,
  } = useCtaButtonAnimation();

  const handleCtaButtonClick = () => {
    window.open(url, '_blank');
    if (isPreview) {
      return;
    }
    if (typeof historyId === 'string') {
      submitBulkCtaButtonAction({
        historyId,
        linkRecord: {
          id,
          page,
          url,
        },
      });
    }
  };

  return (
    <AnimatePresence mode="wait">
      <Styled.AnimationWrapper animate={buttonAnimationControls}>
        <Styled.CtaAnimationButton
          id={GOOGLE_EVENT_ID.cta}
          animate={textWrapperAnimationControls}
          transition={{ duration: 0.2, ease: 'easeInOut' }}
          onClick={handleCtaButtonClick}
        >
          <Styled.CtaButtonText
            id={GOOGLE_EVENT_ID.cta}
            animate={textAnimationControls}
            variant="lg-semibold"
            color="white"
            transition={{ duration: 0.05, ease: 'easeInOut' }}
          >
            {button}
          </Styled.CtaButtonText>
        </Styled.CtaAnimationButton>
      </Styled.AnimationWrapper>
    </AnimatePresence>
  );
};

export default CtaButton;
